import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Typography, Button, IconButton, Snackbar, TextField } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { GET_FAVORITES, DELETE_FAVORITE } from '../graphql/favorites';

const useStyles = makeStyles(() => ({
    root: { padding: '2rem' },
    imageWrapper: { position: 'relative' },
    image: {
        maxWidth: '100%',
        maxHeight: '200px',
        borderRadius: '8px',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
        transition: 'transform 0.3s ease-in-out',
        cursor: 'pointer',
        '&:hover': { transform: 'scale(1.05)' },
    },
    deleteButton: {
        position: 'absolute',
        top: 5,
        right: 5,
        backgroundColor: 'white',
        zIndex: 5,
    },
    shareButton: { marginTop: '2rem', marginRight: '1rem' },
    clearButton: { marginTop: '2rem', marginRight: '1rem' },
    linkField: { marginTop: '2rem', width: '100%' },
}));

function FavoritePage({ t }) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const email = localStorage.getItem('favoriteEmail');

    const { data, loading, refetch } = useQuery(GET_FAVORITES, { variables: { email } });
    const [deleteFavorite] = useMutation(DELETE_FAVORITE);

    const [favorites, setFavorites] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState('');
    const [shareLink, setShareLink] = useState('');

    useEffect(() => {
        if (!loading && data) {
            setFavorites(data.userFavorites);
        }
    }, [data, loading]);

    const handleExport = () => {
        const list = favorites.map(fav => fav.image_url).join('\n');
        const blob = new Blob([list], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'favorites.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleRemove = async id => {
        await deleteFavorite({ variables: { id } });
        await refetch();
        setSnackbarMsg('Favorite removed');
        setSnackbarOpen(true);
    };

    const handleClearAll = async () => {
        await Promise.all(favorites.map(fav => deleteFavorite({ variables: { id: fav.id } })));
        await refetch();
        setSnackbarMsg('All favorites cleared');
        setSnackbarOpen(true);
    };

    const handleGoToPhoto = photoId => {
        const albumId = localStorage.getItem('albumId') || '124002209';
        // history.push(`/album/${albumId}?photo=${photoId}`);
        history.push(`/shoppage/photo_id/${photoId}`);
    };

    const handleGenerateShareLink = () => {
        const payload = btoa(JSON.stringify(favorites));
        const url = `${window.location.origin}/favorites/share/${payload}`;
        setShareLink(url);
        setSnackbarMsg('Shareable link generated');
        setSnackbarOpen(true);
    };

    return (
        <div className={classes.root}>
            <Typography variant="h4" gutterBottom>
                {t('favoritePage:Your Favorite Photos')} ({favorites.length})
            </Typography>
            {/*<Typography variant="body1" gutterBottom>*/}
            {/*    {email ? `Saved for: ${email}` : 'No email linked.'}*/}
            {/*</Typography>*/}

            <Grid container spacing={3}>
                {favorites.length === 0 ? (
                    <Typography variant="body2">{t('favoritePage:No favorites selected yet')}</Typography>
                ) : (
                    favorites.map(fav => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={fav.id}>
                            <div className={classes.imageWrapper}>
                                <IconButton
                                    className={classes.deleteButton}
                                    onClick={() => handleRemove(fav.id)}
                                    size="small"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                                <LazyLoadImage
                                    className={classes.image}
                                    src={fav.image_url}
                                    alt={`Photo ${fav.photo_id}`}
                                    onClick={() => handleGoToPhoto(fav.photo_id)}
                                />
                            </div>
                        </Grid>
                    ))
                )}
            </Grid>

            {favorites.length > 0 && (
                <>
                    {/*<Button variant="contained" color="primary" className={classes.shareButton} onClick={handleExport}>*/}
                    {/*    {t('Export Favorites')}*/}
                    {/*</Button>*/}
                    <Button variant="outlined" color="secondary" className={classes.clearButton} onClick={handleClearAll}>
                        {t('favoritePage:Clear All')}
                    </Button>
                    {/*<Button variant="outlined" className={classes.clearButton} onClick={handleGenerateShareLink}>*/}
                    {/*    {t('Generate Share Link')}*/}
                    {/*</Button>*/}
                    {/*{shareLink && (*/}
                    {/*    <TextField*/}
                    {/*        className={classes.linkField}*/}
                    {/*        fullWidth*/}
                    {/*        variant="outlined"*/}
                    {/*        value={shareLink}*/}
                    {/*        InputProps={{ readOnly: true }}*/}
                    {/*        onClick={e => e.target.select()}*/}
                    {/*    />*/}
                    {/*)}*/}
                </>
            )}

            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message={snackbarMsg}
                action={
                    <IconButton size="small" color="inherit" onClick={() => setSnackbarOpen(false)}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            />
        </div>
    );
}

export default withTranslation('favorites')(FavoritePage);
